import { useEffect, useState, useRef, useContext } from 'react';
import '../../../styles/game/GameBoard.css';
import { useData, useSocket } from '../../../providers/SocketContext.jsx'


function Countdown({isGameState, chatBar}) {
    const socket = useSocket();
    const [countdownState, setCountdownState] = useState(null)
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!socket) {
            return
        }



        socket.emit('countdown_state')

        socket.on('get_countdown_state', (res) => {
            const parse = parseFloat(res)
            setCountdownState(parse);
        })

        return () => {
            socket.off('countdownState');
            socket.off('get_countdown_state');
        }
    }, [socket])

    useEffect(() => {
        if(!socket) {
            return
        }

        socket.on('teste', (res) => {
            console.log('TESTE   ' + res)
        })

        return () => {
            socket.off('teste')
        }
    }, [socket])



    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        const official = new Image();
        const image = new Image();
        official.src = '/assets/img/official.svg';
        image.src = '/assets/img/partners-logo.svg'


        const drawImage = () => {
            const pixelRatio = window.devicePixelRatio || 1; // Получаем pixelRatio устройства
            context.setTransform(1, 0, 0, 1, 0, 0); // Сброс трансформаций
            context.scale(pixelRatio, pixelRatio); // Применяем масштаб для контекста
        
            let imageWidth;
            let imageHeight;
            let officialWidth = 105;
            let officialHeight = 73;
            let numb;
            let officialNum;
        
            // Устанавливаем размеры и параметры в зависимости от размеров canvas
            if (canvas.height / pixelRatio > 320 && canvas.width / pixelRatio > 600) {
                imageWidth = Math.max(310, 175);
                imageHeight = Math.max(121, 100); // Фиксированная высота изображения
                officialNum = 40;
                numb = 57;
            } else if (canvas.height / pixelRatio < 320 || canvas.width / pixelRatio < 600) {
                imageWidth = Math.max(150, 150);
                imageHeight = Math.max(59, 59); // Фиксированная высота изображения
                numb = 47;
                officialNum = 0;
            }
        
            // Очищаем canvas перед перерисовкой
            context.clearRect(0, 0, canvas.width, canvas.height);
        
            // Рисуем изображение
            context.drawImage(
                image,
                (canvas.width / pixelRatio) / 2 - imageWidth / 2, // Центрирование по ширине
                (canvas.height / pixelRatio) / 2 - imageHeight / 2 - numb, // Центрирование по высоте
                imageWidth,
                imageHeight
            );
        
            context.drawImage(
                official,
                (canvas.width / pixelRatio) / 2 - officialWidth / 2, // Центрирование по ширине
                (canvas.height / pixelRatio) / 2 + officialNum, // Центрирование по высоте
                officialWidth,
                officialHeight
            );
        };
        // const drawBar = () => {
        //     let numb;
        //     if (canvas.height > 320 && canvas.width > 600) {
        //         numb = 22
        //     } else if (canvas.height < 320 || canvas.width < 600) {
        //         numb = -8
        //     }
        //     context.lineWidth = 4.5;
        //     context.lineCap = 'round';
        //     context.strokeStyle = '#E50539';


        //     context.beginPath();
        //     context.moveTo((canvas.width / 2) - 100, canvas.height / 2 + numb);
        //     context.lineTo((canvas.width / 2) + 100, canvas.height / 2 + numb);
        //     context.stroke();
        // }
        const drawBar = (countdown, maxCountdown) => {
            const pixelRatio = window.devicePixelRatio || 1; // Учитываем pixelRatio устройства
            const duration = countdown * 1000; // Устанавливаем длительность анимации в зависимости от countdown
            const startTime = performance.now(); // Начальное время анимации
            const initialProgress = countdown / maxCountdown; // Начальное значение прогресса (0 - 1)
        
            const animate = (currentTime) => {
                const elapsed = currentTime - startTime; // Прошедшее время
                const progress = Math.max(0, initialProgress - (elapsed / duration)); // Рассчитываем текущий прогресс
        
                // Сбрасываем трансформации и очищаем canvas
                context.setTransform(1, 0, 0, 1, 0, 0);
                context.clearRect(0, 0, canvas.width, canvas.height);
        
                // Масштабируем контекст
                context.scale(pixelRatio, pixelRatio);
        
                // Рисуем задний фон и изображение
                drawImage();
                drawBgBar();
        
                // Определяем вертикальную позицию
                let numb = canvas.height / pixelRatio > 320 && canvas.width / pixelRatio > 600 ? 22 : -8;
        
                // Настройка стилей линии
                context.lineWidth = 4.5;
                context.lineCap = 'round';
                context.strokeStyle = '#E50539';
        
                // Полная длина линии
                const fullLength = 200;
                const currentLength = fullLength * progress;
        
                // Отрисовываем линию, если её длина больше 0
                if (currentLength > 0) {
                    context.beginPath();
                    context.moveTo(
                        (canvas.width / pixelRatio) / 2 - fullLength / 2, 
                        (canvas.height / pixelRatio) / 2 + numb
                    );
                    context.lineTo(
                        (canvas.width / pixelRatio) / 2 - fullLength / 2 + currentLength, 
                        (canvas.height / pixelRatio) / 2 + numb
                    );
                    context.stroke();
                }
        
                // Если анимация ещё не завершена, вызываем следующий кадр
                if (progress > 0) {
                    requestAnimationFrame(animate);
                }
            };
        
            // Запускаем анимацию
            requestAnimationFrame(animate);
        };
        
        const drawBgBar = () => {
            const pixelRatio = window.devicePixelRatio || 1; // Учитываем pixelRatio устройства
        
            // Определяем вертикальную позицию
            let numb = canvas.height / pixelRatio > 320 && canvas.width / pixelRatio > 600 ? 22 : -8;
        
            // Сбрасываем трансформации и масштабируем контекст
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.scale(pixelRatio, pixelRatio);
        
            // Настройка стилей линии
            context.lineWidth = 4.5;
            context.lineCap = 'round';
            context.strokeStyle = '#262830';
        
            // Отрисовываем задний фон линии
            context.beginPath();
            context.moveTo(
                (canvas.width / pixelRatio) / 2 - 100, 
                (canvas.height / pixelRatio) / 2 + numb
            );
            context.lineTo(
                (canvas.width / pixelRatio) / 2 + 100, 
                (canvas.height / pixelRatio) / 2 + numb
            );
            context.stroke();
        };
        const resizeCanvas = () => {
            const parent = canvas.parentElement;
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            // Получаем размеры контейнера
            const width = parent.offsetWidth;
            const height = parent.offsetHeight;
      
            // Учитываем devicePixelRatio
            const pixelRatio = window.devicePixelRatio || 1;

            // Устанавливаем физические размеры canvas
            canvas.width = canvas.offsetWidth * pixelRatio;
            canvas.height = canvas.offsetHeight * pixelRatio;
      
            // Устанавливаем CSS-ширину и высоту
            // canvas.style.width = `${width}px`;
            // canvas.style.height = `${height}px`;

            // Масштабируем контекст для улучшения качества 
            context.scale(pixelRatio, pixelRatio);
            
            drawImage()
            
            if (countdownState && countdownState > 0) {
                
                drawBar(5, 5)
                
            }
            


            
      
          };

          image.onload = () => {
            
            resizeCanvas(); // Инициализируем размеры и рисуем изображение
        };

          window.addEventListener('resize', resizeCanvas);

          return () => {
              window.removeEventListener('resize', resizeCanvas);
            };
    }, [countdownState, chatBar])

    return (
        <>
            <div className={'countdown-wrapper'}>
            <canvas
                ref={canvasRef}></canvas>
            </div>
        </>
    )
}

export default Countdown;